import { core } from "../../lib/api";

// Core's AgentPromptPayload fields. PATCH builds the new version from `prompt` alone, so any
// field not carried over is lost from the version.
const PROMPT_FIELDS = [
  "system_prompt", "first_message", "calendar", "call_infields", "call_outcomes", "outcome_single_winner",
  "primary_outcome", "tool", "sentence_catalogue", "thinker_cases", "talker_cases", "stt_language",
  "language_switch", "primary_language", "secondary_language", "language_switch_percent", "transfer",
  "authored_sections",
] as const;

export interface AgentVersionDoc {
  version_id: string;
  version_name?: string;
  [field: string]: unknown;
}

export function promptFromVersion(version: AgentVersionDoc, systemPrompt: string): Record<string, unknown> {
  const prompt: Record<string, unknown> = {};
  PROMPT_FIELDS.forEach((field) => {
    if (version[field] !== undefined) prompt[field] = version[field];
  });
  prompt.system_prompt = systemPrompt;
  return prompt;
}

export const fetchCurrentVersion = (agentId: string) =>
  core<AgentVersionDoc>(`/api/v1/agents/${encodeURIComponent(agentId)}/versions/current`);

export async function saveCandidateAsVersion({
  agentId,
  baseVersionId,
  candidatePrompt,
  versionName,
}: {
  agentId: string;
  baseVersionId: string;
  candidatePrompt: string;
  versionName: string;
}): Promise<void> {
  // Checked again at save time: the page may have been open while someone published.
  const current = await fetchCurrentVersion(agentId);
  if (current.version_id !== baseVersionId) {
    throw new Error("The agent has a newer version than the one this proposal was made from. Start a new run.");
  }
  const path = `/api/v1/agents/${encodeURIComponent(agentId)}`;
  await core(path, {
    method: "PATCH",
    body: JSON.stringify({ version_name: versionName, prompt: promptFromVersion(current, candidatePrompt) }),
  });
  await core(`${path}/publish`, { method: "POST" });
}
